// extracted by mini-css-extract-plugin
module.exports = {"socialImageLink":"Menu_socialImageLink__3WXyC","socialImage":"Menu_socialImage__3A4aC","address":"Menu_address__1UoVQ"};